import { Pipe, PipeTransform } from '@angular/core';
import {
  ProductInterface,
  VariantItemInterface,
} from '../../../../core/interfaces/product/product';

@Pipe({
  name: 'providerProductFindVariantItem',
  standalone: true,
})
export class ProviderProductFindVariantItemPipe implements PipeTransform {
  transform(
    value: string,
    product: ProductInterface
  ): VariantItemInterface | undefined {
    return product.VariantItems.find((f) => f.Code === value);
  }
}
